// removed by extract-text-webpack-plugin
module.exports = {"filterCol":"_1wIS0AO-4DXX2Yd_zIF6LG","filterField":"_2jD8JRYbEJALpk8K1EbWCv","addText":"VmsS1iyiuD3dGTjxMt8-F","returnCol":"_1SkheEtNYCUKnQbFYm59Jp","addCol":"mHUcoC6B9syY3Z8etiMHN","headerIcon":"_12DCsIWQUFfa0kTrhDjjhf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/EditClientHeader.css
// module id = 727
// module chunks = 0